export default "__VITE_ASSET__$1icITYs__"